
import { computed, defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const store = useStore();

    onMounted(() => {
      console.log("mounted");
      console.log(store.getters.currentUser);
    });

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const signOut = () => {
      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: "sign-in" }));
    };

    return {
      signOut,
      currentUser,
    };
  },
});
